// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-o_hr","advertDetailParameterList__header":"c-o_hs","advertDetailParameterList__list":"c-o_ht"};